import Resource from '@/api/resources/Resource'

class PersonnelEventTypesServices extends Resource {
    async getAllPersonnelEventTypesDays() {
        const response = await this.axios.get(`/common/personnelEventTypes/`)
        return response.data
    }
}

export default new PersonnelEventTypesServices()
